
// state
import axios from 'axios'
import Question from '../../components/forms/question'
import * as types from '../mutation-types'

export const state = {
	questions: null,
	answers: [],
	sections: null
}

// getters
export const getters = {
	questions: state => state.questions,
	sections: state => state.sections,
	answers: state => state.answers,
	getAnswerByKey: (state) => (key) => {
		return state.answers.find(a => a.key === key)
	}
}

export const mutations = {

	[types.FETCH_QUESTIONS_SUCCESS] (state, data) {
		state.questions = data.questions
		state.sections = data.sections
		state.answers = []
	},

	[types.UPDATE_QUESTIONS] (state, { questions }) {
		state.questions = questions
	},

	[types.FETCH_QUESTIONS_FAILURE] (state) {
		state.questions = []
	},

	[types.CLEAR_QUESTIONS] (state) {
		state.questions = []
	},

	[types.UPDATE_ANSWERS] (state, { answers }) {
		state.answers = answers
	},

	[types.ADD_ANSWER] (state, answer) {
		const index = state.answers.findIndex(d => {
			return d.key === answer.key
		})

		if (index === -1) {
			state.answers.push(answer)
		} else {
			state.answers[index] = answer
		}
	},

	[types.CLEAR_ANSWERS] (state) {
		state.answers = []
	},

	[types.UPDATE_SECTIONS] (state, { sections }) {
		state.sections = sections
	},

	[types.CLEAR_SECTIONS] (state) {
		state.sections = null
	}

}

export const actions = {

	async fetchQuestions ({ commit }) {
		try {
			const existingForm = localStorage.getItem('luEnquiry')

			if (!existingForm) {
				await axios.get('/api/get-enquiry-questions')
          .then(response => {
	const questionObjects = []
	const sections = [{ id: 0, name: 'information', displayName: 'Information', display: false }]

	if (response.data.sections.length === 0) {
		return false
	}

	response.data.sections.forEach(question => {
            // create the stages
		sections.push({
			id: question.id,
			name: question.name,
			displayName: question.name,
			display: true
		})

            // create a new array of question objects
		question.questions.forEach(subQuestion => {
			subQuestion.section_name = question.name
			subQuestion.fields.map(field => {
				if (typeof field.isVisible === 'undefined') {
					field.isVisible = true
				}
				return field
			})
			questionObjects.push(new Question(subQuestion))
		})
	})

	commit(types.FETCH_QUESTIONS_SUCCESS, { questions: questionObjects, sections: sections })
})
          .catch(error => {
	commit(types.CLEAR_QUESTIONS)
	commit(types.CLEAR_SECTIONS)
})
			}
		} catch (e) {
			commit(types.FETCH_QUESTIONS_FAILURE)
		}
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/store/modules/form.js